import React from 'react'
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Button from '@material-ui/core/Button';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import EmailIcon from '@material-ui/icons/Email';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import styles from "../Contact/Contact.module.css";
import emailjs from 'emailjs-com';
import Resume from "../Data/My_Resume.pdf";
import {USER_ID, TEMPLATE_ID, SERVICE_ID} from "./emailkey"

const Contact = () => {

    const [email, setEmail] = React.useState(false)
    const [load, setLoad] = React.useState(false)
    const [err, setErr] = React.useState(false)

    const newTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    const handleButtonClick = () => {
        const newTab = window.open("https://drive.google.com/file/d/11xMHMopjYo5Gm_FCDKZmlkOxrCrom6WO/view", '_blank');

        setTimeout(() => {
            const downloadLink = document.createElement('a');
            downloadLink.href = "https://gdurl.com/7I3FJ/download";
            downloadLink.download = "abhishek_chauhan_fw11-306.jpg";

            document.body.appendChild(downloadLink);
            downloadLink.click();

            document.body.removeChild(downloadLink);
        }, 100);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, e.target, USER_ID)
          .then((result) => {
            setEmail(true);
          }, (error) => {
            setErr(true);
        });
        e.target.reset()
    }

    return (
        <Container id="contact" maxWidth="xl" className={styles.main}>
            <Box className={styles.title}>
                <span>Contact Me</span>
            </Box>
            <Box className={styles.infoContainer}>
                <Box className={styles.linksBox}>
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={< LinkedInIcon/>}
                        onClick={()=>newTab("https://www.linkedin.com/in/abhishek-chauhan-3a78a21b4/")}
                    >
                        LinkedIn
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={< GitHubIcon/>}
                        onClick={()=>newTab("https://github.com/29ab")}
                    >
                        GitHub
                    </Button>   
                    <Button                     
                        variant="contained"
                        color="secondary"
                        startIcon={< EmailIcon/>}
                    >
                        <a href="mailto:abhishekchauhan29101996@gmail.com" className={styles.dTag} download>
                            Email
                        </a>
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={< FileCopyIcon/>}
                        onClick={handleButtonClick}
                    >
                        <span>My Resume</span>
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        // startIcon={< />}
                    >
                        Mobile no.: 7903189379, 7070584909   
                    </Button>            
                </Box>
            </Box>
        </Container>
    )
}

export {Contact}